import React, { Component } from "react";
import intl from "react-intl-universal";
import {
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock
} from "react-bootstrap";
import LoaderButton from "./LoaderButton";
import DivsPattern from "./skylineDesignPattern";

class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      isChangePasswordFailed: false,
      failedMessage: "",
      isLoading: false,
      newPasswordDisabled:true,
      confirmedPasswordDisabled:true,
      passwordInputType: "password",
      newPasswordInputType: "password",
      confirmNewPasswordInputType: "password"
    };
  }

  validateForm() {
    var mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))((?=.*[a-z])(?=.*[0-9]))((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})");
    return (
      this.state.currentPassword.length > 0 &&
      this.state.newPassword.length > 0 && mediumRegex.test(this.state.newPassword) &&
      this.state.confirmNewPassword.length > 0 &&
      this.state.newPassword === this.state.confirmNewPassword
    );
  }

handleChange = event => {
    if (event.target.id.includes("newPassword")){
      var mediumRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
      if (!mediumRegex.test(event.target.value)){
        this.setState({ isChangePasswordFailed: true ,confirmedPasswordDisabled:true});
        this.setState({ failedMessage: intl.get("Password_Illegal") });
      }
      else{
        this.setState({ isChangePasswordFailed: false, confirmedPasswordDisabled:false });
      }
    }
    if (event.target.id.includes("confirmNewPassword")){
      if (event.target.value !== this.state.newPassword){
        this.setState({ isChangePasswordFailed: true });
        this.setState({ failedMessage: intl.get("Password_Not_Match") });
      }
      else{
        this.setState({ isChangePasswordFailed: false });
      }
    }
    if (!event.target.id.includes("confirmNewPassword") && !event.target.id.includes("newPassword") ){
      if (event.target.value.length >= 8){
        this.setState({newPasswordDisabled:false});
      }
      else{
        this.setState({newPasswordDisabled:true,confirmedPasswordDisabled:true});
      }

    }
  
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleSubmit = event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    fetch(process.env.REACT_APP_API_URL + "ChangePassword", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        oldPassword: this.state.currentPassword,
        newPassword: this.state.newPassword
      })
    })
      .then(res => res.json())
      .then(result => {
        if (result.Result == "success") {
          this.setState({ isChangePasswordFailed: false });
          this.setState({ isLoading: false });
          return this.props.history.push("/account");
        } else {
          this.setState({ isChangePasswordFailed: true });
          if (result.Result === "Validation") {
            switch (result.Validations[0].ValidationCode.toString()) {
              case "PasswordIllegal":
                this.setState({ failedMessage: intl.get("Password_Illegal") });
                break;
              default:
                this.setState({ failedMessage: intl.get("The_password_you_entered_is_incorrect") });
                break;
            }
          } else this.setState({ failedMessage: intl.get("The_password_you_entered_is_incorrect") });
          this.setState({ isLoading: false });
        }
      })
      .catch(error => {
        console.error(error);
        this.props.handleServerError(true);
      });
  };

  render() {
    return (
      <DivsPattern headerText={intl.get("Change_Password_Title")}>
        <form className="form-signin" onSubmit={this.handleSubmit}>
          <FormGroup controlId="currentPassword" className="form-label-group">
            <FormControl
              value={this.state.currentPassword}
              onChange={this.handleChange}
              value={this.state.password}
              type={this.state.passwordInputType}
              placeholder={intl.get("Current_Password")}
              className="form-control"
              required
            />
            <a
              onClick={(event) => {
                console.log(this.state.passwordInputType);
                this.state.passwordInputType === "password"
                  ? this.setState({ passwordInputType: "text" })
                  : this.setState({ passwordInputType: "password" });
                }
              }
            >
              <i
              className={
                this.state.passwordInputType === "password"
                ? "fa fa-eye-slash fa-flip-horizontal"
                : "fa fa-eye"
              }
              style={{
                color: "gray",
                right: "16px",
                position: "absolute",
                top: "17px",
              }}
              aria-hidden="true"
              />
            </a>
          </FormGroup>
          <FormGroup controlId="newPassword" className="form-label-group">
            <FormControl
              value={this.state.newPassword}
              onChange={this.handleChange}
              type={this.state.newPasswordInputType}
              placeholder={intl.get("New_Password")}
              className="form-control"
              disabled = {this.state.newPasswordDisabled}
              required
            />
            <a
              onClick={(event) => {
              this.state.newPasswordInputType === "password"
                ? this.setState({ newPasswordInputType: "text" })
                : this.setState({ newPasswordInputType: "password" });
              }}
            >
              <i
              className={
                !this.state.newPasswordDisabled ? 
                this.state.newPasswordInputType === "password"
                ? "fa fa-eye-slash fa-flip-horizontal"
                : "fa fa-eye"
                : null
              }
              style={{
                color: "gray",
                right: "16px",
                position: "absolute",
                top: "17px",
              }}
              aria-hidden="true"
              />
            </a>
          </FormGroup>
          <FormGroup
            controlId="confirmNewPassword"
            className="form-label-group"
          >
            <FormControl
              value={this.state.confirmNewPassword}
              onChange={this.handleChange}
              type={this.state.confirmNewPasswordInputType}
              placeholder={intl.get("Confirm_Password_Text")}
              className="form-control"
              disabled = {this.state.confirmedPasswordDisabled}
              required
            />
            <a
              onClick={(event) => {
              this.state.confirmNewPasswordInputType === "password"
                ? this.setState({ confirmNewPasswordInputType: "text" })
                : this.setState({ confirmNewPasswordInputType: "password" });
              }}
            >
              <i
              className={
                !this.state.confirmedPasswordDisabled ? 
                this.state.confirmNewPasswordInputType === "password"
                ? "fa fa-eye-slash fa-flip-horizontal"
                : "fa fa-eye"
                : null
              }
              style={{
                color: "gray",
                right: "16px",
                position: "absolute",
                top: "17px",
              }}
              aria-hidden="true"
              />
            </a>
          </FormGroup>
         
          <LoaderButton
            block
            className="btn btn-lg btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2"
            disabled={!this.validateForm()}
            type="submit"
            isLoading={this.state.isLoading}
            text={intl.get("Change_Password")}
            loadingText={intl.get("Changing_Password")}
          />
           {this.state.isChangePasswordFailed ? (
            <div id="divError">
              <span style={{ color: "red", whiteSpace:"break-spaces"}}>{this.state.failedMessage}</span>
            </div>
          ) : null}
        </form>
      </DivsPattern>
    );
  }
}

export default ChangePassword;
